import { createCustomEnum } from "./createcustomEnum";

export const CountriesList = createCustomEnum({
	UnitedStates: {
		value: "US",
		name: "UnitedStates",
		displayName: "United States",
	},
	Canada: {
		value: "CA",
		name: "Canada",
		displayName: "Canada",
	},
});
